'use strict';

/** @type {import('./range')} */
module.exports = RangeError;



//////////////////
// WEBPACK FOOTER
// ./~/es-errors/range.js
// module id = 1437
// module chunks = 1